import script from "./InvestmentJointVenture.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestmentJointVenture.vue?vue&type=script&setup=true&lang=js"

import "./InvestmentJointVenture.vue?vue&type=style&index=0&id=b8d0d202&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d0d202"]])

export default __exports__